import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Row, Input, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import PassengersreviewDetail from '../../components/review/PassengersreviewDetail';
import { connect } from "react-redux";
import Steppers from "../../components/search/Steppers";
import PriceFormatter from '../../components/misc/PriceFormatter';
import * as moment from 'moment';
import 'moment-timezone';
import FlightReviewDetails from '../../components/review/FlightreviewDetail'
import { API_URL } from "../../config/Config";
import axios from "axios";
import qs from 'qs';
import axiosRetry from 'axios-retry';
import { ACCESS_TOKEN } from "../../redux/actions/setting";
import { setReserve, setBusIssue } from "../../redux/actions/ticket";
import SaveLoader from "../../components/loader/SaveLoader";


axiosRetry(axios, { retries: 3 });


class Ticketreview extends Component {
    constructor(props) {
        super(props);
        const total = Number(this.props.ticket.review_ticket.data.ticket.totalFare) + (Number(this.props.ticket.review_ticket.data.ticket.totalFare) * .06);
        this.state = {
            loading: false, plzlogin: false, cupon: 0,
            discunt: { discount_amount: 0, discount_percent: 0 },
            finaldiscount: 0,
            total_price: total,
            review: this.props.ticket.review_ticket.data,
            fee: Number(this.props.ticket.review_ticket.data.ticket.totalFare) * .06,
        }
        this.handelConfirm = this.handelConfirm.bind(this);

    }
    componentDidMount() {
        const userlogin = JSON.parse(JSON.parse(localStorage["persist:root"]).user)
        if (localStorage.length !== 0 && userlogin.apiToken !== null) {
            this.setState({ plzlogin: true })
        } else {
            this.setState({ plzlogin: false })
        }
    }
    async handelConfirmCupon() {
        this.setState({ loading: true })
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                // 'X-ZUMO-AUTH': access_token,
                // 'Content-Type': 'application/json',
            },
            // data: qs.stringify(reserve),
            url: API_URL + 'coupon-code/' + this.state.cupon,
        };

        let get_discont = await axios(options);
        if (get_discont.status < 200 || get_discont.status > 300) {
            const error = new Error(get_discont.statusText);
            error.get_discont = get_discont;
            console.log(error);
        } else {
            const review = Number(this.state.review.ticket.totalFare);
            const persent = Number(get_discont.data.data.discount_percent / 100);
            const amount = Number(get_discont.data.data.discount_amount);
            const finaldiscount = (review * persent) + amount;
            const total_price = (review - (review * persent)) - amount;
            const fee = total_price * .06
            // const finaldiscount = amount;
            // console.log(persent)
            // console.log(amount)
            // console.log(review * persent)
            // console.log(finaldiscount)
            this.setState({
                fee,
                finaldiscount
                , total_price: total_price + fee
                , loading: false
            });
        }
    }

    async handelConfirm() {
        console.log(this.props.ticket.review_ticket);
        if (this.props.user.email === 'info@iranroute.com') {
            console.log('adminessssssssssss');
            try {
                this.setState({ loading: true })
                const rph = this.props.ticket.review_ticket.data.ticket.airItineraryRph;
                const access_token = localStorage.getItem(ACCESS_TOKEN);
                const ticket = this.props.ticket.review_ticket;
                let data;
                if (ticket.data.api_token === null) {
                    data = {
                        "adultNo": ticket.data.adultNo,
                        "childNo": ticket.data.childNo,
                        "infantNo": ticket.data.infantNo,
                        "user":
                        {
                            "email": ticket.data.user.email,
                            "cell_phone": ticket.data.user.cell_phone,
                            "tel": ticket.data.user.tel,
                            "whatsapp": ticket.data.user.whatsapp
                        },
                        "passengers": ticket.rev_passengers,
                        "Rph": rph,
                        "altrabo_token": access_token
                    }
                } else {
                    data = {
                        "adultNo": ticket.data.adultNo,
                        "childNo": ticket.data.childNo,
                        "infantNo": ticket.data.infantNo,
                        "passengers": ticket.rev_passengers,
                        "Rph": rph,
                        "altrabo_token": access_token,
                        "api_token": ticket.data.api_token
                    }
                }
                console.log(data);
                const options = {
                    method: 'POST',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: qs.stringify(data),
                    url: API_URL + 'airplane-ticket-register',
                };
                let response = await axios(options);
                console.log(response);
                if (response.status === 200) {
                    this.setState({ loading: false })
                    const reserve = {
                        "user_id": response.data.data.user.id,
                        "altrabo_token": access_token,
                        "ExternalBookIds": response.data.bookingReferences,
                        "user_ticket_id": response.data.data.id,
                        "ticket_type": "airplane"
                    }
                    console.log(reserve)
                    this.props.setReserve(reserve);
                    this.props.setBusIssue(response.data);
                    alert("Attention Your Ticket is Issue with Admin User you can download it in next page");
                    window.location.replace("/Paymentgetway");
                }


            } catch (e) {
                let apiError = await e.response;
                if (apiError === undefined) {
                    console.log(e);
                } else {
                    let statusText = await apiError.statusText;
                    console.log(statusText);

                }
            }
        } else {
            try {
                this.setState({ loading: true })
                const rph = this.props.ticket.review_ticket.data.ticket.airItineraryRph;
                const access_token = localStorage.getItem(ACCESS_TOKEN);
                const ticket = this.props.ticket.review_ticket;
                let data;
                if (ticket.data.api_token === null) {
                    data = {
                        "adultNo": ticket.data.adultNo,
                        "childNo": ticket.data.childNo,
                        "infantNo": ticket.data.infantNo,
                        "user":
                        {
                            "email": ticket.data.user.email,
                            "cell_phone": ticket.data.user.cell_phone,
                            "tel": ticket.data.user.tel,
                            "whatsapp": ticket.data.user.whatsapp
                        },
                        "passengers": ticket.rev_passengers,
                        "Rph": rph,
                        "altrabo_token": access_token
                    }
                } else {
                    data = {
                        "adultNo": ticket.data.adultNo,
                        "childNo": ticket.data.childNo,
                        "infantNo": ticket.data.infantNo,
                        "passengers": ticket.rev_passengers,
                        "Rph": rph,
                        "altrabo_token": access_token,
                        "api_token": ticket.data.api_token
                    }
                }
                console.log(data);
                const options = {
                    method: 'POST',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: qs.stringify(data),
                    url: API_URL + 'airplane-ticket-register',
                };
                let response = await axios(options);
                console.log(response);
                if (response.status === 200) {
                    this.setState({ loading: false })
                    const reserve = {
                        "user_id": response.data.data.user.id,
                        "altrabo_token": access_token,
                        "ExternalBookIds": response.data.bookingReferences,
                        "user_ticket_id": response.data.data.id,
                        "ticket_type": "airplane"
                    }
                    console.log(reserve)
                    this.props.setReserve(reserve);
                    alert("Attention Your Ticket has been reserved by us. You have 10 minutes to Pay it.")
                    window.location.replace("/Paymentgetway")
                }


            } catch (e) {
                let apiError = await e.response;
                if (apiError === undefined) {
                    console.log(e);
                } else {
                    let statusText = await apiError.statusText;
                    console.log(statusText);

                }
            }
        }






    }
    handleChange(e) {
        this.setState({ cupon: e.target.value })
    }

    render() {
        const { ticket } = this.props;
        // console.log(ticket.review_ticket)

        const passenger = ticket.review_ticket.data.passengers;
        // const review = ticket.review_ticket.data;
        const arrivalDate = ticket.review_ticket.data.ticket.arrivalDate;
        // console.log(this.props.ticket.review_ticket.data.ticket.totalFare)
        // console.log(passenger)
        return (
            <div className="Ticketreview pt-5 mt-5">
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Container className="min-height-500">
                    <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Ticket Review</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <Steppers active={2} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Ticket Information</h4>
                        </Col>
                        <Col md='12' sm='12' >
                            <FlightReviewDetails data={ticket.orgTicket} adultNo={ticket.adultNo} childNo={ticket.childNo} infantNo={ticket.infantNo} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Passengers Information</h4>
                        </Col>
                        <Col md='12' sm='12' >
                            <PassengersreviewDetail data={passenger} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Invoice Summary</h4>
                        </Col>

                        <Card className="white mb-3 w-100 flight-item tick-rew-card">
                            <CardBody>
                                <Col md='12' sm='12' >
                                    <span className="coupan-span" >
                                        Coupan Code :
                                    </span>
                                    <Input
                                        // invalid={("passportId" in errors)}
                                        name="Coupan-Code"
                                        type="text"
                                        placeholder="Coupan Code"
                                        // value={fields.passportId}
                                        onChange={this.handleChange.bind(this)}
                                        // onBlur={this.handleBlur.bind(this)}
                                        className=" coupan-input"
                                    />
                                    <Button className="Coupan-submit"
                                        onClick={this.handelConfirmCupon.bind(this)}
                                    >
                                        Submit
                                    </Button>
                                </Col>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="white mb-3 w-100 flight-item tick-rew-card">
                            <CardBody>
                                <Col className='price-review-col' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Price :
                                        </span>
                                        <span className='price-review-content'>

                                            <PriceFormatter
                                                className="item-price"
                                                data={ticket.review_ticket.data.ticket.totalFare}
                                                type="airplane"
                                                date={moment(arrivalDate, 'dd DD MMM').format("YYYY-M-D")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Discount :
                                        </span>
                                        <span className='price-review-content'>
                                            {/* {review.discount !== null ? review.discount : '0'} */}
                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.finaldiscount}
                                                type="airplane"
                                                date={moment(arrivalDate, 'dd DD MMM').format("YYYY-M-D")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col-end' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            6% Service Fee :
                                        </span>
                                        <span className='price-review-content'>

                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.fee}
                                                type="airplane"
                                                date={moment(arrivalDate, 'dd DD MMM').format("YYYY-M-D")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col-end' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Total Price :
                                        </span>
                                        <span className='price-review-content'>
                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.total_price}
                                                type="airplane"
                                                date={moment(arrivalDate, 'dd DD MMM').format("YYYY-M-D")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                            </CardBody>
                        </Card>
                    </Row>

                    <Button className="agree-and-go" onClick={this.handelConfirm} >
                        {/* <Link to="/sales-invoice"> */}
                        Confirm informations
                        {/* </Link> */}
                    </Button>
                </Container>
            </div >
        )
    }

}
const mapStateToProps = (state) => {
    return {
        user: state.user,
        ticket: state.ticket
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setReserve: (reserve) => {
            dispatch(setReserve(reserve))
        },
        setBusIssue: (reserve) => {
            dispatch(setBusIssue(reserve))
        },
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Ticketreview)



// WEBPACK FOOTER //
// ./src/containers/search/Ticketreview.jsx